import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Route } from 'react-router';
import { Layout } from './components/layout';
import { Home } from './components/home';
import { LogOut } from './components/logOut';
import { LogIn } from './components/logIn/logIn';
import { Error } from './components/error';

import './custom.css';
import { routes } from './components/common/routes';
import { SignUp } from './components/signUp/signUp';
import { ResetPasswordPage } from './components/resetPassword/resetPasswordPage';
import { ResetPasswordMessage } from './components/resetPassword/resetPasswordMessage';
import { UpdatePasswordPage } from './components/resetPassword/updatePasswordPage';
import { UpdatePasswordSuccess } from './components/resetPassword/updatePasswordSuccess';
import { SignInWithSsoPage } from './components/signInWithSso/signInWithSsoPage';
import { SignInWithSsoSuccess } from './components/signInWithSso/signInWithSsoSuccess';
import { SignUpActivate } from './components/signUp/signUpActivate';

const App = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Route exact path={routes.home} component={Home} />
                <Route exact path={routes.logIn} render={() => <LogIn />}  />
                <Route path={routes.logOut} component={LogOut} />
                <Route path={routes.error} component={Error} />
                <Route path={routes.register} render={() => <SignUp />} />
                <Route path={routes.resetpassword} render={() => <ResetPasswordPage />} />
                <Route path={routes.resetpasswordmessage} render={() => <ResetPasswordMessage />} />
                <Route path={routes.updatepassword} render={() => <UpdatePasswordPage />} />
                <Route path={routes.updatepasswordsuccess} render={() => <UpdatePasswordSuccess />} />
                <Route path={routes.signInWithSso} render={() => <SignInWithSsoPage />} />
                <Route path={routes.signInWithSsoSuccess} render={() => <SignInWithSsoSuccess />} />
                <Route path={routes.signUpActivate} render={() => <SignUpActivate />} />
            </Layout>
        </BrowserRouter>
    );
};

export default App;
